import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { useBookingDetailsStore } from '@/scopes/account/booking-details/infrastructure/useBookingDetailsStore'
import { getAvailableCancelBookingOptions } from '@/scopes/account/booking-details/pages/selectors'
import { RadioButtonInput } from '@/scopes/common/components/FormElements/RadioButtonInput'
import { CANCEL_BOOKING_OPTION_REGISTRY } from '../cancelBookingOptionRegistry'

export function SelectCancelBookingOptionStep() {
  const { formatMessage } = useIntl()
  const availableOptions = useBookingDetailsStore(getAvailableCancelBookingOptions)

  const optionItems = availableOptions.map(option => ({
    value: option,
    label: formatMessage({ id: CANCEL_BOOKING_OPTION_REGISTRY[option].labelKey }),
  }))

  return (
    <>
      <Typography variant="body-m-regular-snug" as="p">
        {formatMessage({ id: 'booking_details_cancel_booking_sheet_text' })}
      </Typography>

      <Typography variant="body-m-bold-snug" as="p">
        {formatMessage({ id: 'booking_details_cancel_booking_sheet_select_heading' })}
      </Typography>

      <RadioButtonInput
        name="option"
        items={optionItems}
      />
    </>
  )
}
